import _ from 'lodash';

    

    var QUALITY = {
        BAD: 3,
        FAIR: 2,
        GOOD: 1
    };

    var qualityString = {
        1: 'Good',
        2: 'Fair',
        3: 'Bad'
    }

    /**
     * Returns Jitter quality for a given value.
     *
     * Quality    Jitter
     * ----------------------
     * BAD        Greater than 60ms
     * FAIR       Between 20ms and 60ms
     * GOOD       Less than 20ms
    **/
    function getJitterQuality(value) {
        if (value > 60) {
            return QUALITY.BAD;
        }
        if (value >= 20) {
            return QUALITY.FAIR;
        }
        return QUALITY.GOOD;
    }

    /**
     * Returns Packet Loss quality for a given value.
     *
     * Quality    Packet Loss
     * ----------------------
     * BAD        Greater than 2%
     * FAIR       Between 0.5% and 2%
     * GOOD       Less than 0.5%
    **/
    function getPacketLossQuality(value) {
        if (value > 2) {
            return QUALITY.BAD;
        }
        if (value >= 0.5) {
            return QUALITY.FAIR;
        }
        return QUALITY.GOOD;
    }

    function getQualityString(value) {
        if (qualityString[value]) return qualityString[value];

        return -1;
    }

    function isGood(value) {
        return value === QUALITY.GOOD;
    }

    function isBad(value) {
        return value === QUALITY.BAD;
    }

    function isFair(value) {
        return value === QUALITY.FAIR;
    }

    function getWorstQuality(qualityList) {
        var worst = _.max(qualityList);
        return _.isUndefined(worst) ? 0 : worst;
    }

    export default {
        getJitterQuality: getJitterQuality,
        getPacketLossQuality: getPacketLossQuality,
        getQualityString: getQualityString,
        isGood: isGood,
        isFair: isFair,
        isBad: isBad
    };
